import { Modal } from '@pmi/dsm-react';
import { AgreementApiModel } from '../../../../shared/models/DealModel';
import styles from '../dealDetails.module.scss';
import WarningLogo from './warning-alert-with-border.svg';
import { toDayMonthYear } from '../../../../shared/helpers';

interface EditPointOfContactModalProps {
  deal: AgreementApiModel;
  onCancel?: () => void;
  onConfirm?: () => void;
}

export default function ExpireWarningModal({
  deal,
  onCancel = () => {},
  onConfirm = () => {},
}: EditPointOfContactModalProps) {
  const onCancelHandler = () => {
    onCancel();
  };

  const onConfirmHandler = () => {
    onConfirm();
    // close warning modal on confirm
    onCancel();
  };

  return (
    <Modal
      show
      onClose={onCancelHandler}
      customClassName={styles.expireWarningModal}
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancelHandler,
        },
        {
          titleText: 'Confirm',
          variant: 'primary',
          onClick: onConfirmHandler,
        },
      ]}
    >
      <div className={styles.content}>
        <div className="d-flex flex-column align-content-center align-items-center">
          <div className="d-block mb-3">
            <img src={WarningLogo} alt="Expiring Agreement icon" />
          </div>
          <div>
            <div className={styles.label}>
              Are you sure you want to add People?
            </div>
            <div className={styles.subLabel}>
              This agreement is set to expire on{' '}
              <span className="fw-bold">
                {toDayMonthYear(deal?.expiration)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
